import * as React from 'react';

import {useCustomFieldHandlers} from '../../../core-entity/hooks/use-custom-field-handlers';
import type {UpdateCustomField} from '../../../core-entity/hooks/use-custom-field-handlers';

import {refetchForEvent} from '../../refetch-helpers';

import {useUpdateLeadCustomFieldValue} from '../graphql/hooks/use-update-lead-custom-field-value';

export function useLeadCustomFieldHandlers(leadId: string) {
    const {updateLeadCustomFieldValue} = useUpdateLeadCustomFieldValue();

    const updateCustomField = React.useCallback<UpdateCustomField>(
        ({fieldName, value}) =>
            updateLeadCustomFieldValue({
                id: leadId,
                customFields: [
                    {
                        fieldName,
                        value,
                    },
                ],
            }),
        [leadId, updateLeadCustomFieldValue]
    );

    const onSuccess = React.useCallback(() => {
        refetchForEvent('customFieldUpdated');
    }, []);

    return useCustomFieldHandlers(updateCustomField, onSuccess);
}
